import { Component, OnDestroy, OnInit } from '@angular/core';

import { messageTypeEnum } from '../../../models/message-type-enum.model';
import { messageContentEnum } from '../../../models/message-content-enum.model';
import { MessageService } from '../../../services/message/message.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styles: [`
    .paragraphe{
      all: unset;
      white-space: pre-wrap;
    }
  `]
})
export class MessageComponent implements OnInit, OnDestroy {
  svgPath: string;
  svgClass: string;
  svgDivClass: string;
  show: boolean;
  messageType: messageTypeEnum;
  message: messageContentEnum;
  messageTitle = '';

  constructor(private readonly messageService: MessageService) { }

  ngOnInit(): void {
    this.messageService.params.subscribe((params) => {
      this.messageType = this.updateMessageTitle(params?.messageType);
      this.message = params?.messageContent as messageContentEnum;
      this.svgPath = this.getSvgPath();
      this.svgClass = this.getSvgClass();
      this.svgDivClass = this.getSvgDivClass();
      this.show = params?.show;
    });
  }

  updateMessageTitle(messageType: messageTypeEnum): messageTypeEnum {
    switch (messageType) {
      case messageTypeEnum.ERROR:
        this.messageTitle = 'Erreur';
        break;
      case messageTypeEnum.INFO:
        this.messageTitle = 'Information';
        break;
      case messageTypeEnum.SUCCESS:
        this.messageTitle = 'Succès';
        break;
      case messageTypeEnum.WARNING:
        this.messageTitle = 'Avertissement';
        break;
      default:
        this.messageTitle = 'Message';
        break;
    }
    return messageType;
  }

  ngOnDestroy(): void {
    this.messageService.close();
  }

  getSvgPath() {
    let svgIcon: string;

    switch (this.messageType) {
      case messageTypeEnum.SUCCESS: {
        svgIcon = 'circle-check';
        break;
      }
      case messageTypeEnum.WARNING: {
        svgIcon = 'warning';
        break;
      }
      case messageTypeEnum.ERROR: {
        svgIcon = 'circle-cross';
        break;
      }
      case messageTypeEnum.INFO:
        svgIcon = 'circle-info';
        break;
    }
    return `assets/svg-icons/icon-sprite.svg#"${svgIcon}`;
  }

  getSvgClass() {
    return 'svg-icon svg-' + this.svgPath.split('#')[1];
  }

  getSvgDivClass() {
    let type = this.messageType?.toString();
    if (this.messageType === 'advertissement') {
      type = 'warning';
    }
    return 'o-alert o-alert--' + type;
  }

  hide() {
    this.messageService.close();
  }
}
